export default __webpack_public_path__ + "static/media/add_outline_blue.f63b9c0d.svg";